module.exports = __webpack_public_path__ + "img/nvHai5.410c57d8.png";